import App from './App.svelte';

//import 'quill-emoji/dist/quill-emoji.css'

const app = new App({
	target: document.body,
	props: {
		name: 'Annika'
	}
});

export default app;